let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fnck0")).then(() => parcelRequire('8pCz0'));